module.exports = __webpack_public_path__ + "img/home-visual-03.b8088c95.jpg";